module.exports = __webpack_public_path__ + "media/images/undraw/reserve/online_payments-96072d20a17270e1539936e152b1fbfa.png";